import refs from '../helpers/refs'
import site from '../helpers/site'

class CGenericMasthead {
  constructor (el) {
    this.component = el
    this.$refs = refs(this.component)
    this.site = site()
    // By default background videos are paused, if `backgroundVideoPaused` is not set, then the video will start playing
    this.videoPaused = true

    this.init()
  }

  init () {
    // Currently only used on Char-Griller
    if (this.site === 'chargriller') {
      this.initPauseVideoButton()
    }
  }

  initPauseVideoButton () {
    if (this.$refs.playPauseVideoButton) {
      this.$refs.playPauseVideoButton.addEventListener('click', (e) => {
        e.preventDefault()

        if (this.videoPaused) {
          this.$refs.backgroundVideo.play()
          this.videoPaused = false
          this.$refs.pauseIcon.classList.remove('hidden')
          this.$refs.playIcon.classList.add('hidden')

          // In local storage, keep track of when a video gets paused
          localStorage.setItem('backgroundVideoPaused', 'false')
        } else {
          this.$refs.backgroundVideo.pause()
          this.videoPaused = true
          this.$refs.pauseIcon.classList.add('hidden')
          this.$refs.playIcon.classList.remove('hidden')

          // In local storage, keep track of when a video gets paused
          localStorage.setItem('backgroundVideoPaused', 'true')
        }
      })

      // Check if the video was paused in localStorage or user has set prefers reduced motion, if so, have it start paused
      const isReduced = window.matchMedia('(prefers-reduced-motion: reduce)') === true || window.matchMedia('(prefers-reduced-motion: reduce)').matches === true
      const videoPaused = localStorage.getItem('backgroundVideoPaused') === 'true' || isReduced

      if (!videoPaused) {
        // By default background videos will start paused
        // If `backgroundVideoPaused` is not set, then the video will start playing
        this.$refs.backgroundVideo.play()
        this.videoPaused = false
        this.$refs.pauseIcon.classList.remove('hidden')
        this.$refs.playIcon.classList.add('hidden')
      }
    }
  }
}

window.addEventListener('load', () => {
  document
    .querySelectorAll('[data-c-generic-masthead]')
    .forEach(el => new CGenericMasthead(el))
})
